<template>
  <ul>
    <li class="list01-item" :class="{'is-parent': group1.isFolder, 'is-open': group1.isFolder && group1.isOpen}">
      <div v-if="model.id !== 0" class="label">
        <div class="formparts checkbox">
          <input type="checkbox" :id="'package_product_' + model.itemType + '_' + model.id"
          @change="group1.itemClicked(model)" v-model="group1.isChecked">
          <label :for="'package_product_' + model.itemType + '_' + model.id">{{ model.name }}<FontawesomeIcon icon="check" class="icn" /></label>
        </div>
      </div>
      <template v-if="group1.isOpen && group1.isFolder">
        <PCProfileContractedBooksTreeItem
          v-for="model2 in group1.children"
          :model="model2"
          :key="'books_tree_item_' + model2.id"
          :itemType="group1.childrenItemType"
          @emitItemClicked="group1.emitItemClicked"
        />
      </template>
    </li>
  </ul>
</template>

<script>
import { ref, reactive, computed, watch, defineComponent, onMounted } from '@vue/composition-api'
import PCProfileContractedBooksTreeItem from '@/components/pc/partial/profile/PCProfileContractedBooksTreeItem'
import * as logicProfileContractedBooksTreeItem from '@/logic/profile/ProfileContractedBooksTreeItem'

export default defineComponent({
  name: 'PCProfileContractedBooksTreeItem',
  components: {
    PCProfileContractedBooksTreeItem
  },
  props: {
    model: {
      type: Object,
      required: true
    }
  },
  setup (props, context) {

    onMounted(() => {
      group1.init()
    })

    const group1 = logicProfileContractedBooksTreeItem.getGroup(props, context)

    return {
      group1
    }
  }
})
</script>

<style lang="scss" scoped>
</style>
